export default __webpack_public_path__ + "3308d09ba9acc4d691175c2ddce73ab9.svg";